import Language from './tags/Language';

function Languages() {
  return (
    <div>
      <Language />
    </div>
  );
}

export default Languages;
